import EntityInfoLabel from '../EntityInfoLabel';
// Types
import type { UserInfo } from '@trii/types/dist/Users';
import type { IList } from '@trii/types/dist/Contacts';
import type UseEditContact from '../../hooks/useEditContact/types/UseEditContact';

type BaseProps = {
  title: string;
  value?: string | Date;
  isNotEditable?: boolean;
  options?: UserInfo[] | IList[];
  displayValue?: string;
  constructUpdateObject?: (value: string | Date | null) => object;
  businessId?: string;
  baseUrl?: string;
  spaceId?: string;
  contactId?: string;
  onEntityUpdated?: (entity: unknown) => void;
};

type BirthdayProps = BaseProps & {
  inputType: 'birthday';
  contact: UseEditContact;
  dateFormat: string;
};

type NonBirthdayProps = BaseProps & {
  inputType?: 'text' | 'select' | 'selectBusiness';
  contact?: UseEditContact;
  dateFormat?: string;
};

type Props = BirthdayProps | NonBirthdayProps;

const ContactInfoLabel = (props: Props) => {
  const {
    title,
    value,
    isNotEditable,
    options = [],
    displayValue,
    constructUpdateObject,
    businessId,
    baseUrl,
    spaceId,
    contactId,
    onEntityUpdated,
  } = props;

  if (props.inputType === 'birthday') {
    return (
      <EntityInfoLabel
        entityType="contact"
        entityId={contactId}
        title={title}
        value={value}
        isNotEditable={isNotEditable}
        inputType="birthday"
        options={options as Array<UserInfo | IList>}
        displayValue={displayValue}
        constructUpdateObject={constructUpdateObject}
        contact={props.contact}
        businessId={businessId}
        baseUrl={baseUrl}
        spaceId={spaceId}
        dateFormat={props.dateFormat}
        onEntityUpdated={onEntityUpdated}
      />
    );
  }

  const inputType = props.inputType ?? 'text';

  return (
    <EntityInfoLabel
      entityType="contact"
      entityId={contactId}
      title={title}
      value={value}
      isNotEditable={isNotEditable}
      inputType={inputType}
      options={options as Array<UserInfo | IList>}
      displayValue={displayValue}
      constructUpdateObject={constructUpdateObject}
      businessId={businessId}
      baseUrl={baseUrl}
      spaceId={spaceId}
      onEntityUpdated={onEntityUpdated}
    />
  );
};

export default ContactInfoLabel;
